enum FLUX_RENEW_PASSWORD_CONSTANTS {
    USER_RENEW_PASSWORD_BEGIN = "USER_RENEW_PASSWORD_BEGIN",
    USER_RENEW_PASSWORD_ERROR = "USER_RENEW_PASSWORD_ERROR",
    USER_RENEW_PASSWORD_SUCCESS = "USER_RENEW_PASSWORD_SUCCESS",
    USER_RENEW_PASSWORD_CLEAR = "USER_RENEW_PASSWORD_CLEAR"
}

export default FLUX_RENEW_PASSWORD_CONSTANTS;